
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TrackingUserGroup } from '@/types/Tracking'

@Component({
  name: 'UserGroupItem'
})
export default class UserGroupItem extends Vue {
  @Prop({ required: true })
  group: TrackingUserGroup

  @Prop({ required: false, default: false })
  root: boolean

  @Prop({ required: false, default: false })
  opened: boolean

  @Prop({ required: false, default: 0 })
  selectedId: number

  open = false

  toggleOpen () {
    this.open = !this.open
  }

  created () {
    this.open = this.opened
  }
}
